import dayjs from "dayjs";
dayjs.locale("id");

const useDateTimeParser = (datetime) => {
    return dayjs(datetime).format("DD/MM/YYYY HH:mm") + " WIB";
}

export default useDateTimeParser;